import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OigComponent } from './oig.component';

const routes: Routes = [
  { path: '', component: OigComponent,      },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OigRoutingModule { }
